import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "camera-labels-new" }
const _hoisted_2 = { class: "label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NIcon = _resolveComponent("NIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.items?.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              class: "camera-labels__camera-link"
            }, [
              (_ctx.hasPlay && item.icon === 'camera' && item.isExists)
                ? (_openBlock(), _createBlock(_component_NButton, {
                    key: 0,
                    onAction: ($event: any) => (_ctx.emitPlayAction(item.id)),
                    icon: "play",
                    type: "link"
                  }, null, 8, ["onAction"]))
                : (_ctx.hasIcon && item.icon)
                  ? (_openBlock(), _createBlock(_component_NIcon, {
                      key: 1,
                      name: item.icon
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                type: item.component === 'NButton' ? 'link' : '',
                onClick: item.action,
                class: "camera-label-item"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.groupName) + _toDisplayString(_ctx.formattedSeparator) + _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["type", "onClick"]))
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}